<template>
  <div class="new-home-mian" ref="particles-js" id="particles-js">
    <HomeTopAssembly />
    <el-row :gutter="10" class="new-row-1">
      <el-col :xs="24" :sm="12" :lg="7">
        <div class="new-item-banc banc434">
          <HomeUniversally name="企业危险源信息展示" :href="'/processManager/company'"></HomeUniversally>
          <HomeEnterprise :item="item.enterprise"></HomeEnterprise>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :lg="10">
        <div class="new-item-banc banc434 new-item-banc2 " @click="toDetail('/processManager/areaInfo')"> <img class="new-item-imgs"
            v-if="item.urlList && Array.isArray(item.urlList) && item.urlList.length > 0" :src="item.urlList[0]" /><img
            class="new-item-imgs" v-else src="../assets/homeNew/content12.png" />
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="7">
        <div class="new-item-banc banc434">
          <HomeUniversally name="隐患整改情况" :href="'/processManager/dangerGovern'"></HomeUniversally>
          <HomeRectification :item="item.rectification"></HomeRectification>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :lg="7">
        <div class="new-item-banc banc382">
          <HomeUniversally name="巡查任务完成情况" defineCl="title-mian15" :href="'/processManager/dangerTask'"></HomeUniversally>
          <HomePatrol :item="item"></HomePatrol>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :lg="10">
        <div class="new-item-banc banc382">
          <HomeUniversally name="风险数量比例统计" defineCl="title-mian2" :href="'/processManager/ProcessRiskPoint'"></HomeUniversally>
          <HomeRrisk :item="item.rrisk"></HomeRrisk>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="7">
        <div class="new-item-banc banc382">
          <HomeUniversally name="作业票数据展示" defineCl="title-mian20" :href="'/processManager/workStatistics'"></HomeUniversally>
          <HomeTicket :item="item.ticket"></HomeTicket>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="24">
        <div class="new-item-banc banc434">
          <HomeUniversally name="风险点/风险比较图" defineCl="title-mian20" :href="'/processManager/ProcessRiskPoint'"></HomeUniversally>
          <HomeDanger :item="item.dangerData"></HomeDanger>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { getentErpriseData, getentAreaInfoData, getDangerTaskInfoData, getProcessRiskPointData, getWorkPermitInfoData, getRiskListData } from '@/api/HomeNewData'
import HomeTopAssembly from './components/HomeTopAssembly'
import HomeEnterprise from './components/HomeEnterprise'
import HomeRectification from './components/HomeRectification'
import HomeTicket from './components/HomeTicket'
import HomeRrisk from './components/HomeRrisk'
import HomePatrol from './components/HomePatrol'
import HomeUniversally from './components/HomeUniversally'
import HomeDanger from './components/HomeDanger'
export default {
  name: 'DashboardAdmin',
  components: {
    HomeTopAssembly,
    HomeEnterprise,
    HomeRectification,
    HomeTicket,
    HomeRrisk,
    HomePatrol,
    HomeUniversally,
    HomeDanger
  },
  data() {
    return {
      item: {
        enterprise: {//企业
          companyBaseInfo: {

          }
        },
        urlList: [],//大图  
        rectification: {//整改 
        },
        patrolPercentage: 0,//巡查任务完成情况 
        rrisk: {//风险 
        },
        ticket: [//作业票数据 
        ],
        dangerData: [//风险点 
        ]
      },
      isLoading: false,//是否加载完成
    }
  },
  computed: {
    ...mapState({
      // showSettings: state => state.settings.showSettings
    })
  },
  methods: {
    getData() {
      let _this = this;
      if (!this.isLoading) {
        let index = 0;
        let inLength = 6
        this.isLoading = true//是否加载完成 

        // 获取企业数据
        getentErpriseData().then((res) => {
          if (res.body && res.body.status_code == 100) {
            if (res.body.data) {
              let data = res.body.data
              if (!data.companyBaseInfo) {
                data.companyBaseInfo = {}
              }
              _this.item.enterprise = data
              _this.item.urlList = Array.isArray(data.urlList) && data.urlList.length > 0 ? data.urlList : [];//大图  
            }
          }

          index++
          if (index >= inLength) {
            this.isLoading = false//是否加载完成
          }

        }).catch(err => {
          index++
          if (index >= inLength) {
            this.isLoading = false//是否加载完成
          }
        })


        // 获取大图数据(四色图)
        getentAreaInfoData().then((res) => {
          if (res.body && res.body.status_code == 100) {
            if (res.body.data) {
              _this.item.rectification = res.body.data
            }
          }

          index++
          if (index >= inLength) {
            this.isLoading = false//是否加载完成
          }

        }).catch(err => {
          index++
          if (index >= inLength) {
            this.isLoading = false//是否加载完成
          }
        })

        // 获取巡检任务完成情况数据 
        getDangerTaskInfoData().then((res) => {
          if (res.body && res.body.status_code == 100) {
            if (res.body.data) {
              _this.item.patrolPercentage = res.body.data.completeRatio && !isNaN(Number(res.body.data.completeRatio)) ? Number(res.body.data.completeRatio) * 100 : 0;//巡查任务完成情况 
            }
          }

          index++
          if (index >= inLength) {
            this.isLoading = false//是否加载完成
          }

        }).catch(err => {
          index++
          if (index >= inLength) {
            this.isLoading = false//是否加载完成
          }
        })


        // 获取风险数量比例统计数据 
        getProcessRiskPointData().then((res) => {
          if (res.body && res.body.status_code == 100) {
            if (res.body.data) {
              _this.item.rrisk = res.body.data
            }
          }

          index++
          if (index >= inLength) {
            this.isLoading = false//是否加载完成
          }

        }).catch(err => {
          index++
          if (index >= inLength) {
            this.isLoading = false//是否加载完成
          }
        })


        // 获取作业票数据 
        getWorkPermitInfoData().then((res) => {
          if (res.body && res.body.status_code == 100) {
            if (res.body.data && Array.isArray(res.body.data)) {
              _this.item.ticket = res.body.data
            }
          }
          index++
          if (index >= inLength) {
            this.isLoading = false//是否加载完成
          }

        }).catch(err => {
          index++
          if (index >= inLength) {
            this.isLoading = false//是否加载完成
          }
        })

        // 获取风险点/风险比较图
        getRiskListData().then((res) => {
          if (res.body && res.body.status_code == 100) {
            if (res.body.data && Array.isArray(res.body.data)) {
              _this.item.dangerData = res.body.data
            }
          }
          index++
          if (index >= inLength) {
            this.isLoading = false//是否加载完成
          }

        }).catch(err => {
          index++
          if (index >= inLength) {
            this.isLoading = false//是否加载完成
          }
        })
      }


    },

    setAnimation() {
      particlesJS('particles-js',

        {
          "particles": {
            "number": {
              "value": 10,
              "density": {
                "enable": true,
                "value_area": 1200
              }
            },
            "color": {
              "value": "#ffffff"
            },
            "shape": {
              "type": "circle",
              "stroke": {
                "width": 2,
                "color": "#000000"
              },
              "polygon": {
                "nb_sides": 5
              },
              "image": {
                "src": "img/github.svg",
                "width": 100,
                "height": 100
              }
            },
            "opacity": {
              "value": .8,
              "random": false,
              "anim": {
                "enable": false,
                "speed": 1,
                "opacity_min": 0.1,
                "sync": false
              }
            },
            "size": {
              "value": 5,
              "random": true,
              "anim": {
                "enable": false,
                "speed": 40,
                "size_min": 0.1,
                "sync": false
              }
            },
            "line_linked": {
              "enable": true,
              "distance": 150,
              "color": "#ffffff",
              "opacity": 0.4,
              "width": 1
            },
            "move": {
              "enable": true,
              "speed": 6,
              "direction": "none",
              "random": false,
              "straight": false,
              "out_mode": "out",
              "attract": {
                "enable": false,
                "rotateX": 600,
                "rotateY": 1200
              }
            }
          },
          "interactivity": {
            "detect_on": "canvas",
            "events": {
              "onhover": {
                "enable": true,
                "mode": "repulse"
              },
              "onclick": {
                "enable": true,
                "mode": "push"
              },
              "resize": true
            },
            "modes": {
              "grab": {
                "distance": 400,
                "line_linked": {
                  "opacity": 1
                }
              },
              "bubble": {
                "distance": 400,
                "size": 40,
                "duration": 2,
                "opacity": 8,
                "speed": 3
              },
              "repulse": {
                "distance": 200
              },
              "push": {
                "particles_nb": 4
              },
              "remove": {
                "particles_nb": 2
              }
            }
          },
          "retina_detect": true,
          "config_demo": {
            "hide_card": false,
            "background_color": "#b61924",
            "background_image": "",
            "background_position": "50% 50%",
            "background_repeat": "no-repeat",
            "background_size": "cover"
          }
        }

      );
    },

    toDetail(href) {
      this.$router.push({
        path: href
      })
    }

  },
  created() {

    setTimeout(() => {
      if (this.$refs['particles-js']) {
        this.setAnimation()
      } else {
        setTimeout(() => {
          if (this.$refs['particles-js']) {
            this.setAnimation()
          } else {
            setTimeout(() => {
              if (this.$refs['particles-js']) {
                this.setAnimation()
              }
            }, 1000)
          }
        }, 500)
      }
    }, 200)

  },
  mounted() {
    setTimeout(() => {
      this.getData()
    }, 200)

    setInterval(() => {
      if (!this.isLoading) {
        this.item = JSON.parse(JSON.stringify(this.item))
      }
    }, 30000)
  }
}
</script>

<style lang="scss" scoped>
.new-home-mian {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-image: url('../assets/homeNew/main-back.png');
  background-size: 100% 100%;
  min-width: 900px;
  overflow: hidden;

  .new-item-banc {
    position: relative;
    width: 100%;
    height: 100%;
    background: rgba($color: #081A50, $alpha: 0.7);
    opacity: 1;
    min-height: 382px;
    margin-top: 15px;
    padding: 25px 25px 20px 25px;

  }

  .new-row-1 {
    .banc434 {
      height: 434px;
    }

    .banc382 {
      height: 352px;
    }

    .new-item-imgs {
      width: 100%;
      display: block;
      height: 434px;
    }
  }

  .new-item-banc2 {
    padding: 0px !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

}


</style>
<style>
.new-home-mian > .particles-js-canvas-el {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 66;
  display: none;
}
</style>
